import AuthenticationWrapper from "./pages/AuthenticationWrapper";
import { Route, BrowserRouter, Routes } from "react-router-dom";
import Game from "./pages/Game";
import Coupon from "./pages/Coupon";
import "./index.css"
import RefreshToken from "./pages/RefreshToken";
import { MonitoringProvider } from "./utils/monitoring-context/MonitoringProvider";
import LmsRedirect from "./pages/LmsRedirect";
import AppRedirect from "./pages/AppRedirect";
import AppQrCode from "./pages/AppQrCode";
import {AuthenticationContextProvider} from "./auth/AuthenticationContextProvider";
import { XbErrorBoundary } from "./utils/xb-monitoring";

const App = () => {
    return (
      <XbErrorBoundary componentName="app-shell" trackPageLoad={false}>
        <BrowserRouter>
            <AuthenticationContextProvider>
                <MonitoringProvider>
                    <Routes>
                        <Route element={<XbErrorBoundary componentName="lms-redirect"><LmsRedirect/></XbErrorBoundary>} path="/lms-redirect"/>
                        <Route element={<XbErrorBoundary componentName="coupon"><Coupon/></XbErrorBoundary>} path="/coupon"/>
                        <Route element={<XbErrorBoundary componentName="refresh-token"><RefreshToken/></XbErrorBoundary>} path="/refresh-token"/>
                        <Route element={<XbErrorBoundary componentName="app-redirect"><AppRedirect/></XbErrorBoundary>} path="/get"/>
                        <Route element={<XbErrorBoundary componentName="app-qr-code"><AppQrCode/></XbErrorBoundary>} path="/get-qr"/>
                        <Route element={
                            <XbErrorBoundary componentName="game">
                                <AuthenticationWrapper>
                                    <Game/>
                                </AuthenticationWrapper>
                            </XbErrorBoundary>
                        } path="*"/>
                    </Routes>
                </MonitoringProvider>
            </AuthenticationContextProvider>
        </BrowserRouter>
      </XbErrorBoundary>
    )
}

export default App;
